import { useState } from 'owa-react';
import React from 'react';
import {
    shouldShowFolderPane,
    shouldShowFolderPaneAsOverlay,
    toggleFolderPaneExpansion,
} from 'owa-mail-layout';
import { type StateChangeSource } from 'owa-left-pane-layout/lib/types/StateChangeSource';
import { setDragStateForAddinsView } from 'owa-dnd';

export default function useMailListItemDragEvents(): (() => void)[] {
    // Track folder pane state so we can properly show/hide drag and drop UX
    const [isFolderPaneAutoExpanded, setIsFolderPaneAutoExpanded] = useState(false);

    const onDragStart = (): void => {
        // If the folder pane is collapsed, expand it when dragging starts
        // and the folder pane is not an overlay
        if (!shouldShowFolderPane()) {
            setIsFolderPaneAutoExpanded(true);
            const shouldShowOverlayAsBlocking = shouldShowFolderPaneAsOverlay() ? true : undefined;
            toggleFolderPaneExpansion(
                1,
                false /* persistOnServer */,
                undefined /*newShowFolderPane */,
                shouldShowOverlayAsBlocking
            );
        }
        setDragStateForAddinsView(true);
    };

    const onDragEnd = React.useCallback(() => {
        // If the folder pane was collapsed originally, collapse again it when dragging ends
        // and the folder pane is not an overlay
        if (isFolderPaneAutoExpanded) {
            setIsFolderPaneAutoExpanded(false);
            const shouldShowOverlayAsBlocking = shouldShowFolderPaneAsOverlay() ? false : undefined;
            toggleFolderPaneExpansion(
                1,
                false /* persistOnServer */,
                undefined /*newShowFolderPane */,
                shouldShowOverlayAsBlocking
            );
        }

        setDragStateForAddinsView(false);
    }, [isFolderPaneAutoExpanded]);

    return [onDragStart, onDragEnd];
}
